(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["apex-brand-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('apex-brand-navigation')) {
  customElements.define('apex-brand-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const input = this.querySelector('input');
      const items = [...this.querySelectorAll('[data-brand-item]')];
      const status = this.querySelector('[data-brand-status]');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const filter = () => {
        const query = normalize(input.value);
        let count = 0;
        items.forEach(item => { item.hidden = !normalize(item.textContent).includes(query); if (!item.hidden) count++; });
        this.querySelector('[data-brand-empty]').hidden = count !== 0;
        status.textContent = status.dataset.label.replace('[count]', count);
      };
      this.querySelector('[data-brand-search]').hidden = false;
      input.addEventListener('input', filter, options);
      details.addEventListener('toggle', () => {
        if (!details.open) { input.value = ''; filter(); status.textContent = ''; }
        this.querySelector('ul').scrollTop = 0;
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault(); event.stopPropagation(); details.open = false; this.querySelector('summary').focus();
        }
      }, options);
      document.addEventListener('click', event => {
        if (details.open && !event.composedPath().includes(this)) details.open = false;
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["apex-note-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('apex-note-search')) {
    const indexes = new Map();
    customElements.define('apex-note-search', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const input = this.querySelector('input[type="search"]');
        const values = this.querySelector('[data-note-values] > div');
        const status = this.querySelector('[role="status"]');
        if (!input || !values || !status) return;
        const rows = Array.from(values.children);
        let groups = {};
        const groupSelect = this.querySelector('select');
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
        const filter = () => {
          const term = normalize(input.value);
          let count = 0;
          rows.forEach(row => {
            const id = row.querySelector('input[type="checkbox"]')?.value;
            const group = groups[id] || groupSelect.dataset.other;
            row.hidden = (groupSelect.value !== '' && group !== groupSelect.value) || !normalize(row.textContent + ' ' + (groups[id] || '')).includes(term);
            if (!row.hidden) count++;
          });
          status.textContent = count ? status.dataset.count.replace('[count]', count) : status.dataset.empty;
        };
        const options = {signal: this.controller.signal};
        groupSelect.addEventListener('change', event => { event.stopPropagation(); filter(); }, options);
        input.addEventListener('input', filter, options);
        input.addEventListener('search', filter, options);
        input.addEventListener('change', event => event.stopPropagation(), options);
        input.addEventListener('keydown', event => { if (event.key === 'Enter') event.preventDefault(); }, options);
        this.querySelector('.apex-note-search__controls').hidden = false;
        filter();
        const url = this.dataset.groupIndex;
        if (!indexes.has(url)) {
          indexes.set(url, fetch(url).then(response => {
            if (!response.ok) throw new Error('Note group index unavailable');
            return response.json();
          }).catch(() => { indexes.delete(url); return {}; }));
        }
        const signal = this.controller.signal;
        indexes.get(url).then(index => {
          if (signal.aborted || !this.isConnected) return;
          groups = index;
          if (Object.keys(index).length) {
            const names = [...new Set(rows.map(row => groups[row.querySelector('input[type="checkbox"]')?.value] || groupSelect.dataset.other))].sort((a,b) => a.localeCompare(b));
            groupSelect.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
            names.forEach(name => {
              const option = document.createElement('option');
              option.value = name;
              option.textContent = name;
              groupSelect.append(option);
            });
            this.querySelector('[data-note-group-control]').hidden = false;
          }
          filter();
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
